import { defineStore } from 'pinia';

export const useAgreementStore = defineStore('agreement', {
  state: () => ({
    isLicenseAgreed: false
  }),
  actions: {
    storeIsLicenseAgreed(isAgreed) {
      this.isLicenseAgreed = isAgreed;
    }
  }
});
